export const people = [
    {
      'img_url': 'https://avatar.windsor.io/132',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/877',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GgdjIjCEq6m_tO3BKsbTDFDLH1IjvvA_7Fsxz2G4g=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GhGL285WWEq9SANVtKH6okJcqT2rzuoTifeqMv_72g=s100',
      'color': 'red',
      'distance': 20
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GgcWY2vgvZFgdZ91Ja4Tjf0Es2e_oR5pCw5dEoS7w=s100',
      'color': 'red',
      'distance': 100
    },
    {
      'img_url': 'https://avatar.windsor.io/802',
      'color': 'orange',
      'distance': 80
    },
    {
      'img_url': 'https://avatar.windsor.io/497',
      'color': 'red',
      'distance': 100
    },
    {
      'img_url': 'https://avatar.windsor.io/60',
      'color': 'green',
      'distance': 5
    },
    {
      'img_url': 'https://avatar.windsor.io/607',
      'color': 'red',
      'distance': 100
    },
    {
      'img_url': 'https://avatar.windsor.io/645',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://www.gravatar.com/avatar/929ce9ddfd8694c4eeb70e6492a4c7c1?default=404',
      'color': 'green',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/598',
      'color': 'green',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/771',
      'color': 'red',
      'distance': 80
    },
    {
      'img_url': 'https://avatar.windsor.io/540',
      'color': 'green',
      'distance': 20
    },
    {
      'img_url': 'https://www.gravatar.com/avatar/c8a2f0adab4c2156dee75da0f4e2d3a8?default=404',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTyCMt-zX5sJzba5xwPsItZa5yXJh4TRRjaL-9JHpOxytx2Lx31xwbECv1So9C0H=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/70',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://www.gravatar.com/avatar/096a9fd86590f814f24f1055fe068f4e?default=404',
      'color': 'orange',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/271',
      'color': 'green',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/362',
      'color': 'orange',
      'distance': 60
    },
    {
      'img_url': 'https://avatar.windsor.io/435',
      'color': 'orange',
      'distance': 40
    },
    {
      'img_url': 'https://avatar.windsor.io/37',
      'color': 'orange',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/962',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/126',
      'color': 'red',
      'distance': 60
    },
    {
      'img_url': 'https://avatar.windsor.io/994',
      'color': 'green',
      'distance': 20
    },
    {
      'img_url': 'https://www.gravatar.com/avatar/c77539b917fff1ace87aa76b32836290?default=404',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/518',
      'color': 'orange',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/929',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTzibFxeiKJsnv4WlvTDNfPR1Fh1KZZqyjZoVGL_Mtat4LrTDJ0e3P8pIN9-3rtj=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/430',
      'color': 'green',
      'distance': 0
    },
    {
      'img_url': 'https://www.gravatar.com/avatar/77cc05ab48c0fcde65f4c5044716caa7?default=404',
      'color': 'orange',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/335',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/249',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/311',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/752',
      'color': 'orange',
      'distance': 60
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GjrZmSvkUTjgq4I_yGOUh6qhF_ur0gM9bUlALCE=s100',
      'color': 'orange',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTyxRtuBZJw3kyD85uP7ZYh3MQd4SMeYKno03RYqcXBZNvq4XqlEwXN5nTqKLDUP=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/498',
      'color': 'orange',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GhHRPaN4ugHxGxlH6OYB0jOUrWt-IWq65krY_UAqg=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14Gj3_4eJ6RpF6LRAfstW4OffvCaLBWnNrvLa5vQx=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/603',
      'color': 'red',
      'distance': 70
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GhAVIF4-yKb44Wnsedfuc1i8WX2QjyrDQnBxBxJvQ=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/858',
      'color': 'red',
      'distance': 100
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GiD9r1uy7hROHra8A_clhASzSSMWKIU9_0Uq-1rEA=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://www.gravatar.com/avatar/20cf161e9ae026977521c65366a3ebc0?default=404',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/846',
      'color': 'orange',
      'distance': 80
    },
    {
      'img_url': 'https://www.gravatar.com/avatar/cb49b961d86c1fd0545c8e1a02369aaa?default=404',
      'color': 'green',
      'distance': 0
    },
    {
      'img_url': 'https://www.gravatar.com/avatar/3de51f6032eeba235b9d7cb0b56754c6?default=404',
      'color': 'orange',
      'distance': 90
    },
    {
      'img_url': 'https://avatar.windsor.io/409',
      'color': 'red',
      'distance': 100
    },
    {
      'img_url': 'https://avatar.windsor.io/427',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/714',
      'color': 'orange',
      'distance': 100
    },
    {
      'img_url': 'https://avatar.windsor.io/762',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://www.gravatar.com/avatar/5fb751d65eb711962850bb27e7ef73ed?default=404',
      'color': 'orange',
      'distance': 100
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14Gjzzc75-XnM8hJHj1x7RDKQEDd7Gt3NWcq7aBs9Tg=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/634',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GhFKHdsfE0zzq5cyeGsYzqCGxA3tzfyWBtsJIxB=s100',
      'color': 'red',
      'distance': 40
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14Gj719QUQpciJBu60AZTop5l1HpodZKMYyBwbwWD6A=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14Gg_wD-FWJGH--lR9VXPP0jyuO-LlRVPFvEhoNmZWlE=s100',
      'color': 'orange',
      'distance': 20
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GjN92fVePG0UNggV_seKt9c8z0KDXeiMil_eyXQ5Q=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14Gh8hBc9u08qcSghSxeMcA_a68uyLC3sMSzH2fVAAw=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GgUMo9UYpsrAO4JPya1dxHdLYfOfW-4XYf3K5EN2w=s100',
      'color': 'orange',
      'distance': 20
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GieWAh3SKbFxEIkG6I2xu9pQBHAJgdHaQ0ef4Vc=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTzo6QHTfVmEdRun2xxjTqj9PwfVyblkNIqfp_iC6BEqY6fZGZDKNs3X6pyfxFc8=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTxP0q6GHMBpPfTwq2omM7A6mowIZNtbes76Xhw971A2LcP__4a2HCw67IvdjNhc=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14Gi5PuQ8mqbBICTxIp2FAQTLq4Swf0m01Nk8sandQkc=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14Gid4kb71Ja72ZI86QOhD0DzuX7emiwK_KgCEMKZIg=s100',
      'color': 'green',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/688',
      'color': 'green',
      'distance': 5
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTx73h5kpsfJjROvg7V5jUE8w93dBQFBVH7MDtInY4zMPtDa7IR_EU2KP3_7bHTh=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14Gi0f_-FBdbDcIPW1VgnTZNRFW67OTB6nZwHEU5JiQ=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTwlE90cqIrpTs-JfuUb27N2efhbyJbEcSfbHH7xHlZDpybnzkBh0tU_7MVAO0LZ=s100',
      'color': 'red',
      'distance': 20
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GjPoxXnsOSPe0UF4SJawP6JwNqe2ra0CL3GEs2Oyto=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GgG612sybMGubbBnJ0V8C5LZPXsBUrAABuDDfxk=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14Gid7jkrpPgSLHcaEL7yDNU7ZXTi_tq99foKhJrVHQ=s100',
      'color': 'green',
      'distance': 20
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GgYx4n9usvj55ZlUtV6vz7xUgT7dex_333xhSJ2=s100',
      'color': 'red',
      'distance': 50
    },
    {
      'img_url': 'https://avatar.windsor.io/53',
      'color': 'red',
      'distance': 70
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GgTI_BG8rGDuOcpLsaHLiaN1g9igHwMZvUwMDBG=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTx7k6S81uNuEWYRxR6eAA-VwYdGLAcgV-KMfAb-OEqtnupV0eLkhfY6P3y38san=s100',
      'color': 'red',
      'distance': 40
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GhtmO-c0p80JLfXp6TuKxyzC-rLq_iOicJ4m5lptQ=s100',
      'color': 'green',
      'distance': 70
    },
    {
      'img_url': 'https://avatar.windsor.io/235',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/127',
      'color': 'red',
      'distance': 100
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTykt1IXiPQTKhYVv2IOgz0uLBGnKD4dH9jINYDkOHpP3vB9IU_HVGEIqXJrRPq7=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/431',
      'color': 'orange',
      'distance': 100
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTxiNI5T1GbwTI-4z-mHsdaWrRUti6s6UdXhFE3YLZJOoQA5EJrUmjsTkj1ja5Kc=s100',
      'color': 'red',
      'distance': 30
    },
    {
      'img_url': 'https://avatar.windsor.io/409',
      'color': 'green',
      'distance': 100
    },
    {
      'img_url': 'https://avatar.windsor.io/444',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/590',
      'color': 'orange',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/463',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/631',
      'color': 'orange',
      'distance': 20
    },
    {
      'img_url': 'https://www.gravatar.com/avatar/06c1cd6ba91573f047d57db368cc8f7b?default=404',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/947',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/611',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/966',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/138',
      'color': 'orange',
      'distance': 30
    },
    {
      'img_url': 'https://avatar.windsor.io/0',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/212',
      'color': 'orange',
      'distance': 40
    },
    {
      'img_url': 'https://avatar.windsor.io/81',
      'color': 'orange',
      'distance': 40
    },
    {
      'img_url': 'https://avatar.windsor.io/917',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/568',
      'color': 'red',
      'distance': 30
    },
    {
      'img_url': 'https://avatar.windsor.io/689',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/510',
      'color': 'red',
      'distance': 50
    },
    {
      'img_url': 'https://avatar.windsor.io/87',
      'color': 'green',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/868',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/93',
      'color': 'red',
      'distance': 70
    },
    {
      'img_url': 'https://avatar.windsor.io/559',
      'color': 'orange',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/940',
      'color': 'orange',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/45',
      'color': 'orange',
      'distance': 30
    },
    {
      'img_url': 'https://avatar.windsor.io/793',
      'color': 'red',
      'distance': 100
    },
    {
      'img_url': 'https://avatar.windsor.io/691',
      'color': 'red',
      'distance': 80
    },
    {
      'img_url': 'https://avatar.windsor.io/362',
      'color': 'red',
      'distance': 30
    },
    {
      'img_url': 'https://avatar.windsor.io/918',
      'color': 'green',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/407',
      'color': 'orange',
      'distance': 70
    },
    {
      'img_url': 'https://avatar.windsor.io/62',
      'color': 'red',
      'distance': 100
    },
    {
      'img_url': 'https://avatar.windsor.io/841',
      'color': 'orange',
      'distance': 80
    },
    {
      'img_url': 'https://avatar.windsor.io/246',
      'color': 'red',
      'distance': 100
    },
    {
      'img_url': 'https://avatar.windsor.io/144',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/513',
      'color': 'red',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/599',
      'color': 'green',
      'distance': 0
    },
    {
      'img_url': 'https://avatar.windsor.io/244',
      'color': 'green',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/156',
      'color': 'red',
      'distance': 100
    },
    {
      'img_url': 'https://avatar.windsor.io/69',
      'color': 'green',
      'distance': 0
    },
    {
      'img_url': 'https://avatar.windsor.io/529',
      'color': 'orange',
      'distance': 20
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GjXeQV9_qsRc9MuZoeIZT1X8L84x6YvL64Vgv-STQ=s100',
      'color': 'green',
      'distance': 0
    },
    {
      'img_url': 'https://avatar.windsor.io/7',
      'color': 'green',
      'distance': 0
    },
    {
      'img_url': 'https://avatar.windsor.io/439',
      'color': 'green',
      'distance': 100
    },
    {
      'img_url': 'https://avatar.windsor.io/605',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GjUgwTRfmg4w3N3mvHHuar0ZPYLfEjS7wbjTzYH1g=s100',
      'color': 'red',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/461',
      'color': 'green',
      'distance': 5
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTxcmMaZmiRtSFz6ZXS2koM7ljc8h-3gQKhKaonOfhwylQtQI1aG56lhffGlV2NL=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://www.gravatar.com/avatar/ed0b6e2aea006f04e77298fbd72e2170?default=404',
      'color': 'green',
      'distance': 20
    },
    {
      'img_url': 'https://www.gravatar.com/avatar/ac3ba5b61c78b35c61f0a1874cb23aa9?default=404',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/472',
      'color': 'green',
      'distance': 100
    },
    {
      'img_url': 'https://avatar.windsor.io/230',
      'color': 'green',
      'distance': 20
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GjWojeC3QwDCACTWD_OIUNPjhdGo2oZmyQEAaxIADA=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/293',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/471',
      'color': 'orange',
      'distance': 70
    },
    {
      'img_url': 'https://avatar.windsor.io/916',
      'color': 'orange',
      'distance': 50
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14Gj2vvsYeV4ApkkmoHaOaL2pvxSppRxYqsiIbIspgQQ=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GiV7KY57JqwlXCm_Xu8OIVrNDGV1EoyozLejzSl=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTww4ULCtfQqMb85ikWyAILlnFQyDtf_skiCvVLgbJ767uTlIhjTvhbEv8U2qvCS=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTwB_7bi_MP2ghf8eBDvTQN0ZL17AAJYq2UsXRUeK0mmzEECBDuHITFv778Dw_30=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GhQW78nvnTlIqlIBA34ntrk710b9URorHlZFgoD=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/583',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/422',
      'color': 'red',
      'distance': 30
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTzTQNifpFSO9ceXiMaNB8j1zWkRxaFn3rDgNrjkHaLH2rdUbH6jAqQRiYB7dcFH=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/255',
      'color': 'green',
      'distance': 40
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTxxIEtoNsr2Ny8jsANe2DQmFgSrB6frm0GG9xzUZMwNByVD_I4oP_R8eRcspRk3=s100',
      'color': 'green',
      'distance': 10
    },
    {
      'img_url': 'https://avatar.windsor.io/21',
      'color': 'red',
      'distance': 40
    },
    {
      'img_url': 'https://avatar.windsor.io/79',
      'color': 'green',
      'distance': 5
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/a-/AOh14GhGqTUa3lMgYhjDS2yIe0qm7lH1SMkbULjbUyiarQ=s100',
      'color': 'orange',
      'distance': 30
    },
    {
      'img_url': 'https://lh3.googleusercontent.com/cm/AFNzQTwOBUF10zmzbXUk11wAG60OITSN9Y1_mAsjx_svTcV25l7ePQC_1N2wPZq1Wk4E=s100',
      'color': 'orange',
      'distance': 20
    },
    {
      'img_url': 'https://avatar.windsor.io/937',
      'color': 'green',
      'distance': 5
    },
    {
      'img_url': 'https://avatar.windsor.io/496',
      'color': 'green',
      'distance': 100
    }
  ]
